import { createSlice } from "@reduxjs/toolkit"


const initialState = {
 createAccount: 
    {
      isValidated: false,
      childrenInformations: [],
      guardianInformations: [],
    }
  ,
  showModal:false,
  loading: false,
  error: null,
};


const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setValidated:(state)=>{
      return{
        ...state,
        createAccount: {...state.createAccount,isValidated:true}
      }
     
    },
    updateChildrenInformations: (state, action) => {
       const { index, updatedData } = action.payload;

  const updatedChildrenInformations = [...state.createAccount.childrenInformations];
  updatedChildrenInformations[index] = updatedData;

  return {
    ...state,
    createAccount: {
      ...state.createAccount,
      childrenInformations: updatedChildrenInformations
    }
  };
    },
    setNotValidated:(state)=>{
      return{
        ...state,
        createAccount: {...state.createAccount,isValidated:false}
      }
    
    },
    viewModal:(state)=>{
      return{
        ...state,
        showModal:true
      }
     
    },
    hideModal:(state)=>{
      return{
        ...state,
        showModal:false
      }
      
    },
    createAccountRequest: (state, action) => {
      const { payload } = action;

      return {
        ...state,
        createAccount: {...state.createAccount,childrenInformations:[...state.createAccount.childrenInformations,payload]}
         
      };
    },
    clearStore: (state) => {
      // console.log("clear store ")
     return {
      ...state,
      createAccount: 
      {
        isValidated: false,
        childrenInformations: [],
        guardianInformations: [],
      }
     }
    },
   
    deleteChildInformation: (state, action) => {
      const { id } = action.payload;

      // find the index of the child information to delete
      const index = state.createAccount.childrenInformations.findIndex(
        (info) => info.id === id
      );

      // if the child information was found, remove it from the array
      if (index !== -1) {
        state.createAccount.childrenInformations.splice(index, 1);
      }
    },
    createGuardianRequest: (state, action) => {
      const { payload } = action;

      return {
        ...state,
        createAccount: {...state.createAccount,guardianInformations:[...state.createAccount.guardianInformations,payload]}
      };
    },

    deleteGuardianInformation: (state, action) => {
      const { id } = action.payload;

      // find the index of the child information to delete
      const index = state.createAccount.guardianInformations.findIndex(
        (info) => info.id === id
      );

      // if the child information was found, remove it from the array
      if (index !== -1) {
        state.createAccount.guardianInformations.splice(index, 1);
      }
    },
  

    createAccountSuccess: (state, action) => {
      state.account = action.payload;
      state.loading = false;
    },
    createAccountFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
   
  },
});


export const {
  createAccountRequest,
  createGuardianRequest,
  createAccountSuccess,
  createAccountFailure,
  deleteChildInformation,
  deleteGuardianInformation,
  setValidated,
  setNotValidated,
  viewModal,
  hideModal,
  updateChildrenInformations,
  clearStore
} = accountSlice.actions;

export default accountSlice.reducer